export const GET_DOMAINS_BY_ACCOUNT = 'GET_DOMAINS_BY_ACCOUNT'
export const GET_REGISTERED_DOMAINS_BY_ACCOUNT = 'GET_REGISTERED_DOMAINS_BY_ACCOUNT'
export const GET_LINKED_DOMAINS_BY_ACCOUNT = 'GET_LINKED_DOMAINS_BY_ACCOUNT'
